export const cdnResource = (path: Path) => {
  return `${process.env.assetPrefix || ''}${path}`
}

export const videoResource = (path: Path) => {
  const rootPath = process.env.NEXT_PUBLIC_VIDEO_CDN_DOMAIN || ''
  const resourcePath = cdnResource(`/videos${path}`)
  return `${rootPath}${resourcePath}`
}

export const publicResource = (path: Path) => {
  return `/${process.env.NEXT_PUBLIC_CDN_DIR}/public${path}`
}
